// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import filterFunnel02Icon from "@/assets/icons/filter-funnel-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type FilterFunnel02IconProps = Omit<IconProps, "name">;

export function FilterFunnel02Icon(props: FilterFunnel02IconProps): React.ReactNode {
  return <Icon name={filterFunnel02Icon} {...props} />;
}
